<template>
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="confirmation-modal"
      @shortkey="emitCancel"
    >
      <div 
        id="confirmation-modal-title"
        class="confirmation-modal__title">
        {{ title }}
      </div>
      <div 
        id="confirmation-modal-description"
        class="confirmation-modal__description">
        <span v-html="description" />
      </div>
      <div
        v-if="disclaimer"
        id="confirmation-modal-disclaimer"
        class="confirmation-modal__disclaimer alert alert-danger"
      >
        <span v-html="disclaimer" />
      </div>
      <div class="confirmation-modal__footer">
        <button
          id="cancel-confirmation-modal"
          data-testid="cancel-confirmation-modal"
          class="btn btn--grey"
          @click.once="emitCancel"
        >
          Cancel
        </button>
        <button
          id="accept-confirmation-modal"
          data-testid="accept-confirmation-modal"
          :class="[{ 'btn--red': confirmationType === 'danger' }, 'btn']"
          :disabled="loading"
          @click.once="emitConfirm"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
    <div class="modal-overlay" />
  </div>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    confirmationType: {
      validator: function (value) {
        return ['friendly', 'danger'].includes(value)
      },
    },
    title: {
      type: String,
      default: 'Are you sure?',
    },
    description: String,
    disclaimer: String,
    buttonText: {
      type: String,
      default: 'Confirm',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    emitCancel() {
      this.$emit('cancel')
    },
    emitConfirm() {
      const loadingTimeout = 300
      this.loading = true
      this.$emit('confirm')
      setTimeout(() => {
        this.loading = false
      }, loadingTimeout)
    },
  },
}
</script>

<style lang="scss" scoped>
.confirmation {
  &-modal {
    @include flex-display();
    @include flex-direction(column);
    @include flex-justify-content(space-around);
    @include flex-align-items(center);
    position: fixed;
    top: 25%;
    left: 40vw;
    box-sizing: border-box;
    background: $white;
    border-radius: 5px;
    padding: 1em;
    z-index: 1020;
    width: 450px;
    min-height: 300px;
    box-shadow: 0px 6px 10px 1px rgba(0, 0, 0, 0.2);
    @media #{$mobile} {
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      margin-top: 0;
      box-sizing: border-box;
    }
    &__title {
      font-size: $title-font;
      font-weight: 600;
      color: $black;
      text-align: center;
    }
    &__description {
      color: $dark-grey;
      text-align: center;
      line-height: 1.8em;
      margin-top: 1em;
      margin-bottom: 1em;
    }
    &__disclaimer {
      text-align: center;
      margin: 0 1em 1em;
    }
    &__footer {
      @include flex-display();
      @include flex-justify-content(space-evenly);
      width: 100%;
      @media #{$mobile} {
        @include flex-justify-content(space-between);
      }
    }
  }
}
</style>
